module.exports = __webpack_public_path__ + "img/recipe.ae6adc44.png";